<template>
  <div v-if="false">
    <div class="popup_wrap kesh_image">
      <div class="popup_title">
        <p>SAM2 Assisted EM Analysis</p>
        <a @click="close">
          <div class="btn_close" title="Close">
            <div class="btn_close_box"><span></span><span></span></div>
          </div>
        </a>
      </div>

      <div class="popup_content1">
        <ul class="kesh_stage">
          <li :class="{ 'on': currentStep === 1 }">
            <i class="kesh_num">1</i>
            <p class="kesh_text">이미지 설정</p>
          </li>
          <li :class="{ 'on': currentStep === 2 }">
            <i class="kesh_num">2</i>
            <p class="kesh_text">마스크 작업</p>
          </li>
          <li :class="{ 'on': currentStep === 3 }">
            <i class="kesh_num">3</i>
            <p class="kesh_text">분석 및 저장</p>
          </li>
        </ul>

        <div class="sam2em-main-container">
          <div class="sam2em-image-canvas-section">
            <img
                ref="processedImage"
                :src="processedImageUrl"
                alt="Processing Image"
                @load="onImageLoad"
                style="display: none;"
            >
            <canvas
                ref="imageCanvas"
                @mousedown="handleMouseDown"
                @mousemove="handleMouseMove"
                @mouseup="handleMouseUp"
                @contextmenu.prevent
            ></canvas>
          </div>

          <div class="sam2em-controls-section">
            <div v-if="currentStep === 1" class="control-group-wrapper">
              <div class="control-group">
                <div class="control-group-header"><div class="title">Upload Image</div></div>
                <label for="file-upload" class="custom-file-upload">
                  {{ selectedFile ? selectedFile.name : 'Choose a file...' }}
                </label>
                <input id="file-upload" type="file" @change="handleFileChange" accept="image/*">
                <button @click="uploadImage" :disabled="!selectedFile">Upload and Process Image</button>
                <div v-if="loadingStates.upload" class="loader"></div>
                <p class="status-message">{{ statusMessages.upload }}</p>
              </div>
              <div class="control-group">
                <div class="control-group-header"><div class="title">Set SAM2 Input</div></div>
                <p class="guidance">이미지 위의 빨간 선을 드래그하여 분석할 높이를 조절하세요. 완료 후 버튼을 눌러주세요.</p>
                <button @click="setPredictionImage" :disabled="!processedImageUrl">Set SAM2 Input</button>
                <div v-if="loadingStates.setPrediction" class="loader"></div>
                <p class="status-message">{{ statusMessages.setPrediction }}</p>
              </div>
              <button @click="nextStep" class="btn_next_step" :disabled="!isSamInputSet">다음 단계로</button>
            </div>

            <div v-if="currentStep === 2" class="control-group-wrapper">
              <div class="control-group">
                <div class="control-group-header"><div class="title">Mask Generation</div></div>
                <p class="guidance">
                  - 좌클릭: 점 추가/삭제<br>
                  - 우클릭 & 드래그: 박스 추가/삭제
                </p>
                <button @click="generateBatchMasks">Generate Masks (Grid)</button>
                <div v-if="loadingStates.generate" class="loader"></div>
                <p class="status-message">{{ statusMessages.generate }}</p>
              </div>
              <div class="control-group">
                <div class="control-group-header"><div class="title">Draw Scale Bar</div></div>
                <button @click="toggleDrawScaleBarMode" :class="{ 'active': isDrawingScaleBar }">Draw Scale Bar</button>
                <div class="inline-inputs">
                  <label for="scaleBarLength">Length:</label>
                  <input type="number" v-model.number="scaleBar.length" min="1">
                  <label for="scaleBarUnit">Unit:</label>
                  <select v-model="scaleBar.unit">
                    <option value="nm">nm</option>
                    <option value="μm">μm</option>
                  </select>
                </div>
                <div v-if="loadingStates.scaleBar" class="loader"></div>
                <p class="status-message">{{ statusMessages.scaleBar }}</p>
              </div>
              <button @click="nextStep" class="btn_next_step">다음 단계로</button>
            </div>

            <div v-if="currentStep === 3" class="control-group-wrapper">
              <div class="control-group">
                <div class="control-group-header"><div class="title">Show Particle Figure</div></div>
                <button @click="toggleShowParticleFigure" :class="{ 'active': showParticleFigure }">Show Particle Figure</button>
                <div v-if="loadingStates.particleFigure" class="loader"></div>
                <p class="status-message">{{ statusMessages.particleFigure }}</p>
              </div>
              <div class="control-group">
                <div class="control-group-header"><div class="title">Save State</div></div>
                <button @click="saveState">Save Current State</button>
                <div v-if="loadingStates.saveState" class="loader"></div>
                <p class="status-message">{{ statusMessages.saveState }}</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="popup_footer">
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
  </div>
</template>

<script>
// Vue 2 버전 기준
export default {
  name: 'Sam2EmAnalysisPopup',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 컴포넌트 상태
      jobID: null,
      currentStep: 1,
      isSamInputSet: false,

      // 파일 및 이미지 상태
      selectedFile: null,
      processedImageUrl: '',

      // 로딩 및 메시지 상태
      loadingStates: {
        upload: false,
        setPrediction: false,
        generate: false,
        scaleBar: false,
        particleFigure: false,
        saveState: false,
      },
      statusMessages: {
        upload: '',
        setPrediction: '',
        generate: '',
        scaleBar: '',
        particleFigure: '',
        saveState: '',
      },

      // 캔버스 및 상호작용 상태
      ctx: null,
      currentCropHeight: 630, // 기본 자르기 높이
      isDraggingCropLine: false,
      isDrawing: false,
      isDrawingScaleBar: false,
      showParticleFigure: false,
      startX: 0,
      startY: 0,

      // 스케일 바 입력 상태
      scaleBar: {
        length: 100,
        unit: 'nm',
        rect: null,
      },
    };
  },
  mounted() {
    // 컴포넌트가 마운트될 때 고유 세션 ID 생성
    this.jobID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  methods: {
    // --- 컴포넌트 제어 메서드 ---
    close() {
      // 상태 초기화
      this.currentStep = 1;
      this.processedImageUrl = '';
      this.selectedFile = null;
      this.isSamInputSet = false;
      // ... 기타 상태 초기화
      this.$emit('close');
    },
    nextStep() {
      if (this.currentStep < 3) {
        this.currentStep++;
      }
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
      this.statusMessages.upload = '';
    },

    // --- API 통신 메서드 ---
    async apiCall(endpoint, options, loaderKey, statusKey) {
      this.loadingStates[loaderKey] = true;
      this.statusMessages[statusKey] = 'Processing...';
      try {
        const response = await fetch(endpoint, options);
        if (!response.ok) {
          // 에러 처리
          const errorData = await response.json().catch(() => ({ detail: 'Server error with no details.' }));
          const errorMessage = errorData.detail || `Error: ${response.status}`;
          this.statusMessages[statusKey] = errorMessage;
          alert(errorMessage);
          return null;
        }

        // save_state는 파일 다운로드이므로 특별 처리
        if (endpoint === '/save_state/') {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${this.selectedFile.name.split('.')[0]}_analysis.zip`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          this.statusMessages[statusKey] = 'State saved successfully!';
          return { message: 'State saved successfully!' };
        }

        const data = await response.json();
        if (data.showing_image_url) {
          this.processedImageUrl = `${data.showing_image_url}?t=${new Date().getTime()}`; // 캐시 방지
        }
        this.statusMessages[statusKey] = data.message || 'Operation successful.';
        return data;

      } catch (error) {
        this.statusMessages[statusKey] = `Network error: ${error.message}`;
        return null;
      } finally {
        this.loadingStates[loaderKey] = false;
      }
    },

    async uploadImage() {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('job_id', this.jobID);

      await this.apiCall('/upload_image/', { method: 'POST', body: formData }, 'upload', 'upload');
    },

    async setPredictionImage() {
      await this.sendCropHeightToServer();
      const data = await this.apiCall(
          '/set_prediction_image/',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ job_id: this.jobID }),
          },
          'setPrediction',
          'setPrediction'
      );
      if (data) {
        this.isSamInputSet = true;
      }
    },

    async generateBatchMasks() {
      await this.apiCall(
          '/batch_masks_generate/',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ job_id: this.jobID }),
          },
          'generate',
          'generate'
      );
    },

    async toggleShowParticleFigure() {
      this.showParticleFigure = !this.showParticleFigure;
      await this.apiCall(
          '/set_particle_figure/',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ job_id: this.jobID, show_particle_figure: this.showParticleFigure }),
          },
          'particleFigure',
          'particleFigure'
      );
    },

    async saveState() {
      await this.apiCall(
          '/save_state/',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ job_id: this.jobID }),
          },
          'saveState',
          'saveState'
      );
    },

    // --- 캔버스 상호작용 메서드 ---
    onImageLoad() {
      const img = this.$refs.processedImage;
      const canvas = this.$refs.imageCanvas;
      this.ctx = canvas.getContext('2d');

      // 이미지 크기에 맞춰 캔버스 크기 조정
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;

      this.drawCanvas();
    },

    drawCanvas() {
      if (!this.ctx) return;
      const canvas = this.$refs.imageCanvas;
      const img = this.$refs.processedImage;

      this.ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.ctx.drawImage(img, 0, 0);

      // 자르기 라인 그리기 (분석 피규어 표시 중이 아닐 때만)
      if (this.currentCropHeight >= 0 && !this.showParticleFigure) {
        this.ctx.strokeStyle = 'red';
        this.ctx.lineWidth = 2;
        this.ctx.beginPath();
        this.ctx.moveTo(0, this.currentCropHeight);
        this.ctx.lineTo(canvas.width, this.currentCropHeight);
        this.ctx.stroke();
      }
    },

    getCanvasCoords(event) {
      const canvas = this.$refs.imageCanvas;
      const rect = canvas.getBoundingClientRect();
      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top,
      };
    },

    handleMouseDown(event) {
      if (this.currentStep !== 2) return;

      const { x, y } = this.getCanvasCoords(event);

      // 자르기 라인 드래그 시작 여부 확인
      if (Math.abs(y - this.currentCropHeight) < 10) {
        this.isDraggingCropLine = true;
        this.$refs.imageCanvas.style.cursor = 'ns-resize';
        return;
      }

      this.isDrawing = true;
      this.startX = x;
      this.startY = y;

      if (event.button === 0) { // 좌클릭 (점)
        // mouseup에서 처리
      } else if (event.button === 2) { // 우클릭 (박스)
        // mousemove에서 실시간으로 사각형 그림
      }
    },

    handleMouseMove(event) {
      const { x, y } = this.getCanvasCoords(event);
      const canvas = this.$refs.imageCanvas;

      if (this.isDraggingCropLine) {
        this.currentCropHeight = Math.max(0, Math.min(y, canvas.height));
        this.drawCanvas();
        return;
      }

      if (this.isDrawing && event.buttons === 2) { // 우클릭 드래그 중
        this.drawCanvas(); // 이전 프레임 지우기
        this.ctx.strokeStyle = 'red';
        this.ctx.lineWidth = 2;
        this.ctx.strokeRect(this.startX, this.startY, x - this.startX, y - this.startY);
      }
    },

    handleMouseUp(event) {
      if (this.isDraggingCropLine) {
        this.isDraggingCropLine = false;
        this.$refs.imageCanvas.style.cursor = 'default';
        this.sendCropHeightToServer();
        return;
      }

      if (!this.isDrawing) return;
      this.isDrawing = false;

      const { x, y } = this.getCanvasCoords(event);

      if (event.button === 0) { // 좌클릭
        // 클릭과 드래그를 구분하기 위해 시작점과 끝점 거리 확인
        const distance = Math.sqrt(Math.pow(x - this.startX, 2) + Math.pow(y - this.startY, 2));
        if (distance < 5) { // 작은 움직임은 클릭으로 간주
          this.singleMaskGenOrRemove({ point: [Math.round(x), Math.round(y)] });
        }
      } else if (event.button === 2) { // 우클릭
        const box = [
          Math.round(Math.min(this.startX, x)),
          Math.round(Math.min(this.startY, y)),
          Math.round(Math.max(this.startX, x)),
          Math.round(Math.max(this.startY, y))
        ];
        this.singleMaskGenOrRemove({ box });
      }
    },

    async singleMaskGenOrRemove({ point = null, box = null }) {
      const body = {
        job_id: this.jobID,
        input_point: point,
        input_box: box,
      };
      await this.apiCall(
          '/single_mask_gen_or_remove/',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          },
          'generate',
          'generate'
      );
    },

    async sendCropHeightToServer() {
      await this.apiCall(
          '/set_crop_height/',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              job_id: this.jobID,
              crop_height: Math.round(this.currentCropHeight)
            }),
          },
          'setPrediction', // 로더/상태 메시지를 공유
          'setPrediction'
      );
    },

  }
};
</script>

<style lang="scss" scoped>
/* KeshImageService.vue의 기본 팝업 스타일 */
.popup_wrap {
  display: block;
  position: fixed;
  width: 90%;
  max-width: 1400px;
  height: 90%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.2);
  background-color: #f0f4f8;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
}
.popup_title {
  padding: 15px 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
}
.popup_content1 {
  flex-grow: 1;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.popup_footer {
  padding: 15px 20px;
  text-align: right;
  border-top: 1px solid #e0e0e0;
  background-color: #f9f9f9;
  border-radius: 0 0 12px 12px;
}
.mask_wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
}
.btn_close {
  cursor: pointer;
}
/* 수정됨: 닫기 버튼 텍스트 중앙 정렬 */
.btn_type3 {
  padding: 8px 20px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex; /* Flexbox 적용 */
  align-items: center; /* 수직 중앙 정렬 */
  justify-content: center; /* 수평 중앙 정렬 */
  text-decoration: none; /* a 태그 밑줄 제거 */
  &:hover {
    background-color: #5a6268;
  }
}
.btn_next_step {
  margin-top: auto; /* 그룹 맨 아래에 고정 */
  padding: 12px;
  background-color: #007bff;
  color: white;
  font-weight: bold;
  &:disabled {
    background-color: #a0cffc;
    cursor: not-allowed;
  }
}


/* 수정됨: Kesh 단계별 UI 스타일 중앙 정렬 */
.kesh_stage {
  display: grid; /* Grid 레이아웃 사용 */
  grid-template-columns: repeat(3, 1fr); /* 3개의 동일한 너비의 컬럼 생성 */
  margin-bottom: 20px;
  padding: 0;
  list-style: none;
  border-bottom: 2px solid #dee2e6;
  text-align: center; /* 텍스트 중앙 정렬 */

  li {
    padding-bottom: 10px;
    color: #adb5bd;
    font-weight: bold;
    border-bottom: 4px solid transparent;
    &.on {
      color: #007bff;
      border-bottom-color: #007bff;
    }
  }
}


/* index.html의 레이아웃과 컨트롤 스타일 적용 */
.sam2em-main-container {
  display: flex;
  flex-grow: 1;
  gap: 20px;
  min-height: 0; /* flexbox 자식 높이 문제 해결 */
}

.sam2em-image-canvas-section {
  flex: 3;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  canvas {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.sam2em-controls-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;

  .control-group-wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1; /* 다음 단계 버튼을 맨 아래로 밀기 위함 */
  }
}

.control-group {
  background-color: #ffffff;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.control-group-header .title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
}

button, .custom-file-upload { /* 공통 스타일 적용 대상에 label 추가 */
  width: 100%;
  padding: 10px 15px;
  background-color: #f8f9fa;
  color: #343a40;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  text-align: center;
  display: inline-block; /* label에 필요 */
  box-sizing: border-box; /* 패딩, 보더 포함해서 너비 계산 */

  &:hover {
    background-color: #e9ecef;
  }
  &:active, &.active {
    background-color: #d1e2f7;
    border-color: #a7c5ed;
  }
  &:disabled {
    background-color: #e9ecef;
    color: #adb5bd;
    cursor: not-allowed;
  }
}

/* 추가됨: 파일 업로드 버튼 디자인 통일 */
input[type="file"] {
  display: none; /* 기본 파일 인풋 숨기기 */
}

input[type="number"], select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}
.inline-inputs {
  display: flex;
  gap: 10px;
  align-items: center;
}
p.guidance {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.4;
  background-color: #f8f9fa;
  padding: 8px;
  border-radius: 5px;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
  margin: 10px auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.status-message {
  font-size: 12px;
  color: #28a745;
  text-align: center;
  min-height: 1em; /* 메시지가 없을 때도 공간 차지 */
}

</style>